import { cxApiClient, paymentApiClient } from "@shared/api/clients/apiClientFactory";
import { ApiEndpoints } from "@shared/api/api-endpoints";
import { PaymentAgreementParams, PaymentAgreementResponse, PaymentListParams, PaymentListResponse, CreditNoteListParams, CreditNoteListResponse, CombinedBillsServicesParams, CombinedBillsServicesResponse, PendingConsumerBillsParams, PendingConsumerBillsResponse, CreditNoteDetailParams, CreditNoteDetailResponse, PaymentDetailParams, PaymentDetailResponse } from "./types";

export const billsApi = {
  getPaymentAgreementDetail: async (params: PaymentAgreementParams): Promise<PaymentAgreementResponse> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "consumerWeb",
      "payment-agreement/detail",
      (query) => {
        if (params.remote_utility_id) query.push("remote_utility_id", params.remote_utility_id.toString());
        if (params.consumer_id) query.push("consumer_id", params.consumer_id.toString());
        return query;
      }
    );

    const response = await cxApiClient.get(url);
    return response.data;
  },
  getPaymentList: async (params: PaymentListParams): Promise<PaymentListResponse> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "consumerWeb",
      "payment",
      (query) => {
        if (params.remote_utility_id) query.push("remote_utility_id", params.remote_utility_id.toString());
        if (params.consumer_id) query.push("consumer_id", params.consumer_id.toString());
        if (params.page !== undefined) query.push("page", params.page.toString());
        if (params.limit !== undefined) query.push("limit", params.limit.toString());
        return query;
      }
    );

    const response = await cxApiClient.get(url);
    return response.data;
  },
  getCreditNoteList: async (params: CreditNoteListParams): Promise<CreditNoteListResponse> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "consumerWeb",
      "credit-note",
      (query) => {
        if (params.remote_utility_id) query.push("remote_utility_id", params.remote_utility_id.toString());
        if (params.consumer_id) query.push("consumer_id", params.consumer_id.toString());
        if (params.payment_pay_type) query.push("payment_pay_type", params.payment_pay_type.toString());
        if (params.page !== undefined) query.push("page", params.page.toString());
        if (params.limit !== undefined) query.push("limit", params.limit.toString());
        return query;
      }
    );

    const response = await cxApiClient.get(url);
    return response.data;
  },

  getPaymentServices: async (params: {
    remote_utility_id: string;
    consumer_id: string;
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "cx",
      "payment-services",
      (qs) => {
        qs.push("remote_utility_id", params.remote_utility_id);
        qs.push("consumer_id", params.consumer_id);
      }
    );
    const response = await cxApiClient.get(url);
    return response.data?.result;
  },
  
  getCombinedBillsServices: async (params: CombinedBillsServicesParams): Promise<CombinedBillsServicesResponse> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "consumerWeb",
      "combined-bills-services",
      (query) => {
        if (params.remote_utility_id) query.push("remote_utility_id", params.remote_utility_id);
        if (params.consumer_number) {
          const numbers = Array.isArray(params.consumer_number) 
            ? params.consumer_number 
            : typeof params.consumer_number === 'string' 
              ? params.consumer_number.split(',') 
              : [params.consumer_number];
          numbers.forEach(num => query.push("consumer_number", String(num).trim()));
        }
        if (params.is_pagination_required !== undefined) query.push("is_pagination_required", params.is_pagination_required);
        if (params.type_filter) query.push("type_filter", params.type_filter);
        return query;
      }
    );

    const response = await cxApiClient.get(url);
    return response.data;
  },

  getPendingConsumerBills: async (params: PendingConsumerBillsParams): Promise<PendingConsumerBillsResponse> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "cx",
      "pending-consumer-bills ",
      (query) => {
        if (params.remote_utility_id) query.push("remote_utility_id", params.remote_utility_id);
        if (params.consumer_id) query.push("consumer_id", params.consumer_id);
        return query;
      }
    );

    const response = await cxApiClient.get(url);
    return response.data;
  },

  getCreditNoteDetail: async (params: CreditNoteDetailParams): Promise<CreditNoteDetailResponse> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "cx",
      `credit-note/detail/${params.credit_note_id}`,
      (query) => {
        if (params.remote_utility_id) query.push("remote_utility_id", params.remote_utility_id.toString());
        return query;
      }
    );

    const response = await cxApiClient.get(url);
    return response.data;
  },

  getPaymentDetail: async (params: PaymentDetailParams): Promise<PaymentDetailResponse> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "cx",
      `payments/${params.payment_id}/detail`,
      (query) => {
        if (params.remote_utility_id) query.push("remote_utility_id", params.remote_utility_id.toString());
        return query;
      }
    );

    const response = await cxApiClient.get(url);
    return response.data;
  },
};
